import { render } from "./Markup.vue?vue&type=template&id=2318995e"
import script from "./Markup.vue?vue&type=script&lang=js"
export * from "./Markup.vue?vue&type=script&lang=js"

import "./Markup.vue?vue&type=style&index=0&id=2318995e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__